import type { QuickInsertItem } from '@atlaskit/editor-common/provider-factory';
import { find } from '@atlaskit/editor-common/quick-insert';
import type { QuickInsertSearchOptions } from '@atlaskit/editor-common/types';
import { dedupe } from '@atlaskit/editor-common/utils';
import { fg } from '@atlaskit/platform-feature-flags';

type GetQuickInsertSuggestions = (
	searchOptions: QuickInsertSearchOptions,
	lazyDefaultItems?: () => QuickInsertItem[],
	providedItems?: QuickInsertItem[],
) => QuickInsertItem[];

export const getQuickInsertSuggestions: GetQuickInsertSuggestions = (
	searchOptions,
	lazyDefaultItems = () => [],
	providedItems,
) => {
	// @ts-ignore
	const { query, category, disableDefaultItems, featuredItems, itemFilter, prioritySortingFn } =
		searchOptions;
	const defaultItems = disableDefaultItems ? [] : lazyDefaultItems();

	const dedupeFn = (item: QuickInsertItem) => `${item.title}-${item.description ?? ''}`;

	let items = providedItems ? dedupe([...defaultItems, ...providedItems], dedupeFn) : defaultItems;

	// EDITOR-6558: apply consumer-supplied filter (e.g. Markdown Mode allowlist).
	if (itemFilter) {
		items = items.filter(itemFilter);
	}

	if (featuredItems) {
		return items.filter((item) => item.featured);
	}

	return find(
		(fg('platform_editor_fix_space_triggering_ai') ? query?.trimEnd() : query) || '',
		category === 'all' || !category
			? items
			: items.filter((item) => item.categories && item.categories.includes(category)),
		prioritySortingFn,
	);
};
